<div class="w-28 flex">
    @if (action === 'hi') {
      <img src="/assets/images/willy/resized/willy_hello.png" alt="willy"
          class="object-cover object-top w-full h-full" />
    }
    @if (action === 'thinking') {
      <img src="/assets/images/willy/resized/willy_book2.png" alt="willy"
          class="object-cover object-top w-full h-full" />
    }
    @if (action === 'explaining') {
      <img src="/assets/images/willy/resized/willy_openhands.png" alt="willy"
          class="object-cover object-top w-full h-full" />
    }
    @if (action === 'dontknow') {
      <img src="/assets/images/willy/resized/willy_dontknow.png" alt="willy"
          class="object-cover object-top w-full h-full" />
    }
</div>